import { createAsyncThunk } from "@reduxjs/toolkit";
import { sessionApi, StartSessionResponse } from "../../../services/dataEntering/session/api";
import { fetchData } from "../../../services/dataEntering/data/api";
import { activityApi } from "../../../services/dataEntering/activity/api";
import { ActivityStatusToType, ActivityStatuses, CategoryToFormType } from "./constants";
import { AppDispatch, RootState } from "../../../shared/redux/types";
import { dataEnteringEmpty } from "./sessionSlice";
import { newActivity } from "./activitySlice";

export const startSession = createAsyncThunk<
    StartSessionResponse | undefined,
    void,
    { dispatch: AppDispatch; state: RootState }
>(
    "dataEntering/startSession",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const result = await dispatch(sessionApi.endpoints.startSession.initiate()).unwrap();

            if (!result) {
                dispatch(dataEnteringEmpty());
                return;
            }

            const { data } = await fetchData({ dispatch, ...result });
            const formType = CategoryToFormType[data?.data?.category] ?? null;

            dispatch(newActivity(formType));

            return result;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
    {
        condition: (_, { getState }) => {
            const { dataEntering } = getState();
            return !dataEntering.loading && !dataEntering.accountId;
        },
    },
);

export const stopSession = createAsyncThunk("dataEntering/stopSession", async () => {});

export const endActivity = createAsyncThunk<
    void,
    void,
    { dispatch: AppDispatch; state: RootState }
>("dataEntering/endActivity", async (_, { dispatch, getState, rejectWithValue }) => {
    const state = getState();
    const { activity, dataEntering } = state;

    const { startedAt, entityId, entityType, status } = activity;
    const { accountId, documentId } = dataEntering;

    const type = ActivityStatusToType[status];

    if (!type) {
        return rejectWithValue("Invalid activity status for ending");
    }

    try {
        await dispatch(
            activityApi.endpoints.createActivity.initiate({
                accountingDocumentId: entityId?.toString(),
                accountingDocumentType: entityType,
                accountId,
                documentId,
                type,
                startedAt,
                finishedAt: Date.now(),
            }),
        ).unwrap();

        if (
            [ActivityStatuses.SKIPPED, ActivityStatuses.PROCESSED].includes(
                status as typeof ActivityStatuses.SKIPPED | typeof ActivityStatuses.PROCESSED,
            )
        ) {
            dispatch(stopSession());
        } else {
            dispatch(newActivity());
        }
    } catch (e) {
        return rejectWithValue(e);
    }
});
